import {createAsyncThunk} from '@reduxjs/toolkit';
import {settingsDataFailure, settingsDataRequest, settingsDataSuccess} from '../reducers/settings';
import {get} from '../utils/requests';
import {SWFT_DIGITAL_API_HOST} from '../constants';
import {SETTINGS_ENDPOINT} from '../constants/endpoints';
import Tracker from '../lib/analytics/tracker';
import {ErrorTags, EventNames} from '../lib/analytics/events';

const getSettings = createAsyncThunk('settings/get', async (org_uid: string, thunkAPI) => {
    try {
        thunkAPI.dispatch(settingsDataRequest());
        const data = await get(SWFT_DIGITAL_API_HOST + SETTINGS_ENDPOINT + '?org_uid=' + org_uid);
        Tracker.trackEvent(EventNames.GET_ORG_SETTINGS);
        thunkAPI.dispatch(settingsDataSuccess(data));
    } catch (e: any) {
        Tracker.trackError(e, ErrorTags.GET_ORG_SETTINGS_ERROR, {
            orgUid: org_uid,
        });
        thunkAPI.dispatch(settingsDataFailure());
    }
});

export {getSettings};
